// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// `.env.ts` is generated by the `npm run env` command
import env from "./.env";

export const environment = {
  production: false,
  version: env.npm_package_version + "-dev",
  serverUrl: "/api",
  envName: "DEV",
  API_URL: "https://prod1lqbbff.resmac.com",
  LQB_API_URL: "https://prod1lqbbff.resmac.com",
  LQB_API2_URL: "https://prod2lqbbff.resmac.com",
  OKTA_ISSUER: "https://dev-830016.okta.com/oauth2/default",
  OKTA_REDIRECT_URI: window.location.origin + "/implicit/callback",
  OKTA_CLIENT_ID: "0oalw8p05WcWvdUF04x6",
  GOOGLE_ANALYTICS_ID: "",
  is_taxonomy_static: false,
  is_lp_service_static: false,
  recapture_site_key: "6LfZHuMUAAAAAHERjPWL44BWLdtm6Q6A2qNkgqMm",
  ENCRYPT_PUBLIC_KEY:
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCWv+wpfXxZbXFxAwOxTUZHevyb4qQbn48OLcouYgztTxm3uTAMY2sAics1fFY4weCLgkM1ma2cDYcEaXL6dhc4CENOJbym1oqhw4fNNUliAcGJqzh+Ak81INA1eWOhzRAwPXSBNvB46y0ROkA8WkJMluozMEctO+WlU9/6XZ7tewIDAQAB",
  BULK_PRICING_SAMPLE_TAPE_LINK:
    "https://resmac-corporate.s3.amazonaws.com/Agency-Bulk-Pricing-Sheet+(1).xlsx",
  COMPANY_APP_BASE_URL: "https://corp.resmac.com/company"
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
